import React from 'react'
import { Box, Text } from '@primer/react'

interface IWarningCheckInHocSinhProps {
    data: any
    isInvalid?: boolean
}

const HighlightCheckInHocSinh = ({ data, isInvalid }: IWarningCheckInHocSinhProps) => {
    return (
        <>
            {data.image_url ? (
                <Box
                    sx={{
                        p: 3,
                        borderRadius: 12,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        textAlign: 'center',
                        bg: 'canvas.default',
                        border: isInvalid ? '1px solid #1a7f37' : '1px solid #e1e4e8',
                        maxHeight: `${window.innerHeight - 90}px`
                    }}
                >
                    {/* Ảnh học sinh */}
                    <Box
                        as="img"
                        src={data.image_url}
                        alt={data.ho_ten}
                        sx={{
                            width: '100%',
                            borderRadius: 8,
                            objectFit: 'cover',
                            mb: 2,
                            maxHeight: `${window.innerHeight - 180}px`
                        }}
                    />
                    {/* Họ tên */}
                    <Text
                        as="div"
                        sx={{
                            fontWeight: 700,
                            fontSize: 20,
                            color: 'rgb(9, 105, 218)',
                            textTransform:'uppercase'
                        }}
                    >
                        {data.ma_hs} {' - '}
                        {data.ho_ten} {' - '}
                        {data.ten_lop}
                    </Text>

                    {/* Trạng thái */}
                    {data.gio_diem_danh &&
                        <Text
                            sx={{
                                color: 'success.fg',
                                fontWeight: 600,
                                fontSize: 16,
                            }}
                        >
                            Điểm danh: {data.gio_diem_danh}
                        </Text>
                    }
                </Box>
            ):(
            <Box sx={{
                p: 3,
                borderRadius: 12,
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                textAlign: 'center',
                bg: 'canvas.default',
                border: '1px solid #e1e4e8',
                fontWeight:'600'
            }}>
                Chưa có học sinh điểm danh
            </Box>
            )}
        </>
    )
}

export default HighlightCheckInHocSinh
